export default {
  title: 'Orderfacturen',
  list: {
    empty_list: {
      title: 'Nog geen orderfacturen.',
    },
    fields: {
      id: 'Id',
      total: 'Totaal',
      date: 'Datum',
    },
  },
  export_modal: {
    title: 'Filter',
    start_date: {
      title: 'Startdatum',
      placeholder: 'datum',
    },
    end_date: {
      title: 'Einddatum',
      placeholder: 'datum',
    },
    button: {
      title1: 'Toepassen',
      title2: 'Sluiten',
    },
  },
  toasts: {
    failed_to_load_data: 'Gegevens laden mislukt',
  },
};
